import auth from "../services/authService";
// import store from "../store/modules/login.js";
import axios from "axios";
import {
  trackSignUp,
  eventoLogin,
  motivoDeFallo,
} from "../services/analytics";

axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

export const authMixin = {
  data() {
    return {
      flag: false,
    };
  },
  methods: {
    authenticate: function (provider) {
      var vue_context = this;
      this.$auth
        .authenticate(provider)
        .then(function (response) {
          // eslint-disable-next-line
          FB.api("/me", "post", {
            access_token: response.access_token,
            fields: "email,first_name,last_name,picture.width(100).height(100)",
          });
          // eslint-disable-next-line
        })
        .catch(function (error) {
          console.log(error);
          vue_context.$toasted.error(
            "Ha ocurrido un error en el servidor, intenta más tarde."
          );
          this.$store.commit("login/setUserEmpty");
        });
    },
    // El login con Google vive completo en
    // components/utopie/modals/LoginModalComponent.vue, que ya usa Google
    // Identity Services (google.accounts.id). Aca habia un flujo con popup a
    // accounts.google.com que leia el #id_token de vuelta: murio porque
    // vue-router corre en hash mode y se comia el fragmento, y porque COOP
    // corta la relacion opener<->popup. GSI no usa ni popup propio ni
    // fragmento, asi que no queda nada que compartir por el mixin.

    authenticate_password: function (payload, modal) {
      var vue_context = this;
      eventoLogin("login_attempt", { method: "password" });
      auth
        .authenticate_password(payload)
        .then((response) => {
          if (response.token) {
            eventoLogin("login_success", { method: "password" });
            this.$store.commit("login/setUser", response);
            if (this.flag) {
              modal.handleAuthenticated();
            } else {
              modal.$emit("exit", false);
            }
          } else {
            eventoLogin("login_failure", {
              method: "password",
              reason: "invalid_credentials",
            });
            vue_context.$toasted.error(
              "Revisa tu correo o contraseña, deben estar incorrectas."
            );
            this.$store.commit("login/setUserEmpty");
            // TODO: add form error
          }
          // eslint-disable-next-line
        })
        .catch((error) => {
          var status = error.response && error.response.status;
          // El 404 conserva su nombre —es el unico estado que aca significa
          // algo distinto de un codigo, y ademas cambia el mensaje que se
          // muestra—. El resto sale del clasificador comun, que es el que
          // garantiza que nunca viaje un motivo vacio.
          eventoLogin("login_failure", {
            method: "password",
            reason: status === 404 ? "user_not_found" : motivoDeFallo(error),
          });
          if (status === 404)
            vue_context.$toasted.error("Usuario no existente");
          else if (error.response && error.response.data.message)
            vue_context.$toasted.error(error.response.data.message);
          else
            vue_context.$toasted.error(
              "Ha ocurrido un error en el servidor, intenta más tarde."
            );
          this.$store.commit("login/setUserEmpty");
        });
    },
    register_user: function (payload, modal) {
      var vue_context = this;
      auth
        .register(payload)
        .then((response) => {
          // El alta ya ocurrio: /register/ solo devuelve 200 despues de crear
          // el User y mandarle el correo de activacion; todo lo demas
          // (campos faltantes, correo repetido, clave debil) sale por 403 y
          // cae en el .catch. Que la cuenta nazca is_active=False no cambia
          // que sea un alta: es la misma fila que cuenta la base.
          trackSignUp("password");
          if (response && response.message) {
            // vue_context.$toasted.success(response.message);
            modal.$emit("exit", response.message);
          }
          // TODO: add form error
        })
        .catch((error) => {
          // El alta por formulario fallaba en silencio: este era el unico
          // camino del embudo que no avisaba cuando se caia. `register/`
          // devuelve 403 para todo lo que no sea un alta —campos faltantes,
          // correo repetido, clave debil, y tambien el tope de envios por
          // IP—, asi que en GA4 no habia un solo `error_403` en catorce dias
          // y eso no se podia distinguir de "a nadie le fallo el formulario".
          //
          // Por `eventoLogin` como el resto del embudo: asi el fallo se puede
          // cruzar con el `login_wall_shown` que lo trajo y con
          // `navegador_interno`, que es la mitad de las veces la explicacion.
          //
          // `method: "password"` es el mismo que usa el alta cuando sale bien
          // (`trackSignUp("password")`, mas abajo). Lo que separa un registro
          // fallido de un login fallido es el motivo: `error_403` solo puede
          // venir de aca.
          eventoLogin("login_failure", {
            method: "password",
            reason: motivoDeFallo(error),
          });
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            vue_context.$toasted.error(error.response.data.message);
            // TODO: add form error
          } else {
            vue_context.$toasted.error(
              "Ha ocurrido un error en el servidor, intenta más tarde."
            );
          }
        });
    },
  },
};
